import React from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

export function BookingTable() {
  const { colHeaders, columns, data, rawDataLink, dateHeaderTooltip } = useSelector(
    (state) => state.bookings.tableData
  );

  const tooltipId = "booking-date-table-header-tooltip";

  return (
    <>
      <TableWithCustomSearch
        data={data}
        colHeaders={colHeaders}
        columns={columns}
        rawDataLink={rawDataLink}
        fileName="bookings-table"
        columnHeaderSlot={{
          Date: (
            <div
              className="d-inline"
              data-tooltip-id={tooltipId}
              data-tooltip-content={dateHeaderTooltip}
            >
              Date
            </div>
          )
        }}
      />
      <Tooltip id={tooltipId} float />
    </>
  );
}
